import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ColorApi } from 'api';

import { RootState } from '../app';

export const findColor = createAsyncThunk(
  'color/findColor',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ColorApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
}

const initialState: IState = {
  list: [],
};

const colorSlice = createSlice({
  name: 'color',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findColor.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: colorReducer } = colorSlice;

export default colorReducer;

export const selectColor = (state: RootState): IState => state.color as IState;
